'use strict';

// core version + modules:
import Swiper, {Navigation, A11y, Pagination} from 'swiper';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';

//fonction qui permet de mettre la meme hauteur a ts les titles
function equalizeHeights(container) {
    const items = container.querySelectorAll('.f-imgText__ctn-title');
    let maxHeight = 0;

    items.forEach(item => {
        item.style.height = 'auto';
    });

    items.forEach(item => {
        maxHeight = Math.max(maxHeight, item.offsetHeight);
    });

    items.forEach(item => {
        item.style.height = `${maxHeight}px`;
    });
}

const SliderMulti = {
    els: null,
    init: function () {
        SliderMulti.els = document.querySelectorAll('.f-slider');
        if (SliderMulti.els && SliderMulti.els.length > 0) {
            SliderMulti.els.forEach(el => {
                SliderMulti.create(el);
            });
        }
    },
    create: function (el) {
        const slider = el.querySelector('.swiper');

        const nb = slider.dataset.nb ? parseFloat(slider.dataset.nb) : "auto";
        const nbMobile = slider.dataset.nbMobile ? parseFloat(slider.dataset.nbMobile) : 1;
        const gap = slider.dataset.gap ? parseFloat(slider.dataset.gap) : 0;
        // console.log(nb)

        let swiper = null;
        
        swiper = new Swiper(slider, {
            modules: [Navigation, A11y, Pagination],
            a11y: true,
            spaceBetween: 16,
            slidesPerView: nbMobile,
            loop: false,
            speed: 600,
            autoHeight:false,
            simulateTouch: window.innerWidth <= 768,
            navigation: {
                prevEl: ".f-slider__navigation-prev",
                nextEl: ".f-slider__navigation-next",
            },
            pagination: {
                el: ".f-slider__pagination",
                clickable: true, // rend les bullets cliquables
            },
            breakpoints: {
                768: {
                    spaceBetween: gap,
                    slidesPerView: nb,
                }
            },
            on: {
                init: function () {
                    if (window.innerWidth > 768) { equalizeHeights(el); }
                },
                resize: function () {
                    if (window.innerWidth > 768) { equalizeHeights(el); }
                }
            }
        });
    },
};

export default SliderMulti;